import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IConvo } from '../../../model/convo'
import fetchLikes from './fetch-likes'
import fetchFollows from './fetch-follows'
import fetchAllJybed from './fetch-all-jybed'
import authStore from '@/store/auth/auth-store';

export default async function fetchReactions(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  fetchLikes(context, convo)
  if (authStore.isAuthenticated) {
    fetchFollows(context, convo)
    fetchAllJybed(context, convo)
  }
  return
}
